import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { loadQuestionDetails } from "../../../Redux/actions/questionAction";
import QBPreviewHeader from "./QBPreviewHeader";
import QBPreviewQuestions from "./QBPreviewQuestions";
import QuestionPropertiesModalWrapper from "../QuestionProperties/QuestionPropertiesModalWrapper";
import { Backdrop, Typography } from "@mui/material";
import { resetQuestionState } from "../../../Redux/reducers/questionSlice";
import { QBArea, QBMessageWrapper } from "../question.style";
import QBEmptyPreview from "./QBEmptyPreview";
import Loader from "../../Common/assets/Loader";
import { Languages } from "../../../Redux/reducers/studySlice";

type props = {
  studyId?: string;
  formId: string;
  type: "platform" | "study";
  languages: Languages[];
};
const QuestionPreview: React.FC<props> = ({
  studyId,
  formId,
  type,
  languages,
}) => {
  const dispatch = useAppDispatch();

  const [searchParams] = useSearchParams();
  const lang = searchParams.get("lang") ?? "";
  const loading = useAppSelector((state) => state.question.loading);
  const error = useAppSelector((state) => state.question.error);
  const questions = useAppSelector((state) => state.question.questions);

  useEffect(() => {
    if (formId)
      dispatch(loadQuestionDetails(studyId, formId, type, true, lang));
    return () => {
      dispatch(resetQuestionState());
    };
  }, [dispatch, studyId, formId, lang, type]);

  return (
    <div className="preview-wrapper">
      {loading && (
        <Backdrop
          open={true}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <Loader />
        </Backdrop>
      )}
      <QBPreviewHeader type={type} languages={languages} />
      {error ? (
        <QBMessageWrapper>
          <Typography variant="h3" color="grey">
            {error}
          </Typography>
        </QBMessageWrapper>
      ) : (
        <QBArea style={{ padding: "0px" }}>
          {loading ? null : questions.length === 0 ? (
            <QBEmptyPreview />
          ) : (
            <QBPreviewQuestions />
          )}
          <QuestionPropertiesModalWrapper />
        </QBArea>
      )}
    </div>
  );
};

export default QuestionPreview;
